import Vue from 'vue'
import VueRouter from 'vue-router'
import { BasicLayout, BasicLayoutMobile } from '@/layouts'
import store from '../store'

Vue.use(VueRouter)
const pcIs = store.state.pcIs
const routes = [
  {
    path: '/',
    name: 'index',
    component: pcIs ? BasicLayout : BasicLayoutMobile,
    meta: { title: '首页' },
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import(/* webpackChunkName: "about" */ '@/views/Home/index'),
        meta: {
          title: '首页',
          index: 0
        }
      },
      {
        path: '/product',
        name: 'product',
        component: () => import(/* webpackChunkName: "about" */ '@/views/Product/index'),
        meta: {
          title: '产品中心',
          index: 1
        }
      },
      {
        path: '/solution',
        name: 'solution',
        component: () => import(/* webpackChunkName: "about" */ '@/views/Solution/index'),
        meta: {
          title: '代理加盟',
          index: 2
        }
      },
      {
        path: '/state',
        name: 'state',
        component: () => import(/* webpackChunkName: "about" */ '@/views/State/index'),
        meta: {
          title: '使用说明',
          index: 3
        },
        children: [
          {
            path: 'A',
            name: 'stateA',
            component: () => import(/* webpackChunkName: "about" */ '@/views/State/A.vue'),
            meta: {
              title: '如何发送公众号模板消息?'
            }
          },
          {
            path: 'B',
            name: 'stateA',
            component: () => import(/* webpackChunkName: "about" */ '@/views/State/B.vue'),
            meta: {
              title: '微信公众号如何生成追踪来源的二维码？'
            }
          },
          {
            path: 'C',
            name: 'stateA',
            component: () => import(/* webpackChunkName: "about" */ '@/views/State/C.vue'),
            meta: {
              title: '如何使用粉丝海报？'
            }
          },
          {
            path: 'D',
            name: 'stateA',
            component: () => import(/* webpackChunkName: "about" */ '@/views/State/D.vue'),
            meta: {
              title: '怎么样统计粉丝来源渠道？?'
            }
          },
          {
            path: 'E',
            name: 'stateA',
            component: () => import(/* webpackChunkName: "about" */ '@/views/State/E.vue'),
            meta: {
              title: '如何使用公众号渠道二维码？'
            }
          },
          {
            path: 'F',
            name: 'stateA',
            component: () => import(/* webpackChunkName: "about" */ '@/views/State/F.vue'),
            meta: {
              title: '如何同步汇客软件模版消息?'
            }
          },
          {
            path: 'G',
            name: 'stateA',
            component: () => import(/* webpackChunkName: "about" */ '@/views/State/G.vue'),
            meta: {
              title: '拼红包功能简介'
            }
          },
          {
            path: 'H',
            name: 'stateA',
            component: () => import(/* webpackChunkName: "about" */ '@/views/State/H.vue'),
            meta: {
              title: '分享助力简介'
            }
          },
          {
            path: 'I',
            name: 'stateA',
            component: () => import(/* webpackChunkName: "about" */ '@/views/State/I.vue'),
            meta: {
              title: '拼团购简介'
            }
          },
          {
            path: 'J',
            name: 'stateA',
            component: () => import(/* webpackChunkName: "about" */ '@/views/State/J.vue'),
            meta: {
              title: '到店红包简介'
            }
          }
        ]
      },
      {
        path: '/relation',
        name: 'relation',
        component: () => import(/* webpackChunkName: "about" */ '@/views/Relation/index'),
        meta: {
          title: '公司介绍',
          index: 4
        }
      }
    ]
  },
  {
    path: '/topRecommend/scenicSpot',
    name: 'ScenicSpot',
    component: () => import('@/views/topRecommend/scenicSpot'),
    meta: {
      title: '景点推荐'
    }
  },
  {
    path: '/topRecommend/snack',
    name: 'Snack',
    component: () => import('@/views/topRecommend/snack'),
    meta: {
      title: '美味小吃'
    }
  },
  {
    path: '/topRecommend/preventSwindle',
    name: 'PreventSwindle',
    component: () => import('@/views/topRecommend/preventSwindle'),
    meta: {
      title: '诈骗防范'
    }
  },
  {
    path: '/to/:id',
    name: 'toMiniApp',
    component: () => import('@/views/toMiniApp/index'),
    meta: {
      title: '我是标题'
    }
  },
  {
    path: '/dyto/:id',
    name: 'toMiniApp',
    component: () => import('@/views/toMiniApp/index'),
    meta: {
      title: '我是标题'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }

})
router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  // let meta = document.getElementById('meta-content');
  // meta.content = '嘿哈';
  // let link = document.getElementById('shortcut-icon');
  // link.href = "http://util.gathercloudsaas.com/images/6ab542a65429a9a8be3bf9f61bf66bb57145de2f.png"
  // let linkTwo = document.getElementById('apple-touch-icon');
  // linkTwo.href = "http://util.gathercloudsaas.com/images/6ab542a65429a9a8be3bf9f61bf66bb57145de2f.png"
  
  next()
})
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}
export default router
